import { HighlightColorsEnum } from '../enums';

export const hightlightColors: Record<HighlightColorsEnum, string> = {
  [HighlightColorsEnum.YELLOW]: 'rgb(255, 215, 0)',
  [HighlightColorsEnum.BLUE]: 'rgb(141, 205, 250)',
  [HighlightColorsEnum.PINK]: 'rgb(245, 166, 225)',
};
